import React from 'react';
import { HelpModalContentBody } from '@Components/HelpModal/HelpModal.style';
import { textblocks } from 'seal-ui-components';

const LabelsHelpModalContent = () => (
    <HelpModalContentBody>
        <textblocks.Heading3>Labels</textblocks.Heading3>

        <p>
            The Labels page lists all active models that have extracted relevant language from your
            document. This page also lists all answer fields, even if no relevant answer was found.
        </p>

        <textblocks.Heading3>Extractions</textblocks.Heading3>

        <p>
            Clicking on a Label will expand it and display an Extraction, if one is available.
            Clicking on an Extraction will highlight the corresponding language within the document.
            You can replace the highlighted language with an approved Clause by moving to the
            Clauses page and inserting the correct language from there.
        </p>

        <textblocks.Heading3>Views</textblocks.Heading3>

        <p>
            Views allow you to narrow the list of labels down to a pre-defined subset. A View must
            be created via the Seal platform and will only be visible in the drop-down list on this
            page if the creator has shared it. Clicking the ‘Select view’ drop-down menu and
            selecting a View will display only the Labels contained in that View.
        </p>

        <textblocks.Heading3>Relation To The Scorecard</textblocks.Heading3>
        <p>
            Every item on the Scorecard will correspond to one or more Labels, but not all Labels
            will relate to a Scorecard item. If a Label found relevant language, but has no
            risk-logic tied to it, no Scorecard entry will be created and the Label will only appear
            on the Labels page.
        </p>
    </HelpModalContentBody>
);

export default LabelsHelpModalContent;
